const errorArray = function(){
  let code = new Array();
  code['-1'] = 'redis错误';
  code['-2'] = 'mysql错误';
  code['-3'] = '接口方法错误';
  code['-4'] = '缺少参数';
  code['-5'] = 'http错误';
  code['-6'] = 'sqlite错误';
  code['400'] = '无效的请求';
  code['500'] = '服务端错误';
  code['1000'] = 'admin帐号不存在';
  code['1001'] = '用户没有登录';
  code['1002'] = '密码不匹配';
  code['1003'] = '类型不支持';
  code['1004'] = '机器id不存在';
  code['1005'] = '服务id不存在';
  code['1006'] = '进程id已经存在';
  code['1007'] = '进程id不存在';
  code['1008'] = '没有机器在运行';
  code['1009'] = '没有服务在运行';
  code['1010'] = '没有显示权限';
  code['1011'] = '用户不存在';
  code['1012'] = '查询结果未定义';
  code['1013'] = '应用已经存在';
  code['1014'] = '无效的参数';
  code['1015'] = '字段不支持';
  code['1016'] = 'config值不存在';
  code['1017'] = '工号已存在';
  code['1018'] = '应用不存在';
  code['1019'] = 'playbook执行失败';
  code['1020'] = '导入模块失败';
  code['1021'] = '获取模块方法失败';
  code['1022'] = 'json解析失败';
  code['1023'] = '录像转码安装失败';
  return code;
};
export default errorArray();



// WEBPACK FOOTER //
// ./src/config/constant.js